<template>
  <v-container fluid>
    <div>
      <subscription-filters
        report-type="CANCELLATIONS"
        @period="selectedPeriod = $event"
        @transitionproducttypes="selectedTransitionProductTypes = $event"
        @endtypes="selectedEndTypes = $event"
        @corporatetypes="selectedCorporateTypes = $event"
        @discountcategories="selectedDiscountCategories = $event"
        @nodiscounts="
          noDiscounts = $event;
          selectedDiscountCategories = [];
        "
      />

      <v-row v-if="clubData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="clubData" :options="clubData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="oneOnOneData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="oneOnOneData" :options="oneOnOneData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="lifeData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="lifeData" :options="lifeData"></highcharts>
        </v-col>
      </v-row>
      <v-row v-if="gradData" align="center" justify="center">
        <v-col cols="12" align="center" justify="center">
          <highcharts v-if="gradData" :options="gradData"></highcharts>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import SubscriptionFilters from "@/components/billing/components/SubscriptionFilters";
import SubscriptionReportMixin from "@/components/shared/mixins/SubscriptionReportMixin";

export default {
  name: "CancellationRequests",
  mixins: [SubscriptionReportMixin],
  components: { SubscriptionFilters },
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  data() {
    return {
      reportType: "CANCELLATION_REQUESTS",
    };
  },
};
</script>

<style scoped>
.fake-link {
  cursor: pointer;
}
</style>
